import { render, staticRenderFns } from "./BracBranchAccountForm.vue?vue&type=template&id=1dad6ef3&"
import script from "./BracBranchAccountForm.vue?vue&type=script&lang=js&"
export * from "./BracBranchAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports